import { useMutation } from "@tanstack/react-query";
import { deleteVenue } from "supabase/venues";
import { queryClient } from "utils";

type UseDeleteVenueParams = {
  uid: string;
};

export const useDeleteVenue = (onSuccess: () => any) => {
  const mutation = useMutation({
    mutationFn: ({ uid }: UseDeleteVenueParams) => {
      return deleteVenue({ uid });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["venues"],
      });

      onSuccess();
    },
  });

  return mutation;
};
